

































import { StreamRepository } from '@/core/api/streams'
import Vue from 'vue'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: (): [] => [],
    },
  },
  data: () => ({
    dialog: false,
    streams: [],
    update: {
      streams: [],
    },
  }),
  watch: {
    show(newVal) {
      this.reset()
      new StreamRepository().$getPage(1, { 'page_size': 1000 }).then(response => {
        this.streams = response.results
      })
      this.dialog = newVal
    },
  },
  methods: {
    reset() {
      this.update = {
        streams: [],
      }
    },
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit', this.update)
      this.close()
    },
  },
})
